import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconLinkedinGraph: React.FC<IconProps> = ({ width = 22, height = 24, color = 'white' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.0293 13.5H2.5293C2.11508 13.5 1.7793 13.8358 1.7793 14.25V21.75C1.7793 22.1642 2.11508 22.5 2.5293 22.5H7.0293C7.44351 22.5 7.7793 22.1642 7.7793 21.75V14.25C7.7793 13.8358 7.44351 13.5 7.0293 13.5Z"
                fill={color}
            />
            <path
                d="M22.0293 7.5H17.5293C17.1151 7.5 16.7793 7.83579 16.7793 8.25V21.75C16.7793 22.1642 17.1151 22.5 17.5293 22.5H22.0293C22.4435 22.5 22.7793 22.1642 22.7793 21.75V8.25C22.7793 7.83579 22.4435 7.5 22.0293 7.5Z"
                fill={color}
            />
            <path
                d="M14.5293 1.5H10.0293C9.61508 1.5 9.2793 1.83579 9.2793 2.25V21.75C9.2793 22.1642 9.61508 22.5 10.0293 22.5H14.5293C14.9435 22.5 15.2793 22.1642 15.2793 21.75V2.25C15.2793 1.83579 14.9435 1.5 14.5293 1.5Z"
                fill={color}
            />
        </svg>
    );
};

export default IconLinkedinGraph;
